import type { Method } from 'axios'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'

const request = axios.create({
  withCredentials: true,
})

export const pageEditorHttpClient = async <T>(
  url: string,
  method: Method = 'GET',
  options: AxiosRequestConfig<T> = {},
): Promise<T> => {
  const response: AxiosResponse<T> = await request({
    method,
    url: `/api/dashboard/page-editor/${url}`,
    ...options,
  })
  return response.data
}
